import { useAuthStore } from "@/store/authStore";
import { apiService } from "@/services/apiService";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
export const LOGIN_URL =
  import.meta.env.VITE_LOGIN_URL || "http://google.com";

export function useAuth() {
  const {
    token,
    setToken,
    setIsAuthenticated,
    isAuthenticated,
    user,
    setLogout,
  } = useAuthStore();

  // Function to authenticate user and get tokens
  const authenticate = async () => {
    try {
      // First check user status
      const userStatusResponse = await apiService.getUserStatus().catch((er)=>{
        // window.location.href = LOGIN_URL;
        console.log("error in get user status",er);
      });

      // If user status is OK, get chat token
      const chatTokenResponse = await apiService.getChatToken();

      // If chat token response is OK, set token and authentication status
      if (chatTokenResponse && chatTokenResponse.access_token) {
        setToken(chatTokenResponse.access_token);
        setIsAuthenticated(true);
        return chatTokenResponse;
      }
    } catch (error) {
      toast.error(`Authentication error: ${error}`);
      setToken(null);
      setIsAuthenticated(false);
      return null;
    }
  };

  // Use useQuery to handle authentication
  const authQuery = useQuery({
    queryKey: ["auth"],
    queryFn: authenticate,
    // Prevent automatic refetching
    refetchOnWindowFocus: false,
    // Only run once
    staleTime: Infinity,
    // Don't retry on failure
    retry: false,
  });

  // Function to log out
  const logout = () => {
    setLogout();
  };

  return {
    token,
    isAuthenticated,
    user,
    authenticate: authQuery.refetch,
    logout,
    isLoading: authQuery.isLoading,
    isError: authQuery.isError,
    error: authQuery.error,
  };
}